var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJgSmboloBranco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2",
    "data-name": "Camada 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 302.1 302.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f7f7f7;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elementos"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.17,302.1h37.76c12.59-12.59,25.18-25.18,37.76-37.76v-37.76c-44.06-44.06-88.11-88.11-132.17-132.17v-37.76C50.35,81.82,25.18,106.99,0,132.17v37.76c18.88-18.88,37.76-37.76,56.64-56.64,40.91,40.91,81.82,81.82,122.73,122.73v18.88c-15.73,15.73-31.47,31.47-47.2,47.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M169.93,0h-37.76c-12.59,12.59-25.18,25.18-37.76,37.76v37.76c44.06,44.06,88.11,88.11,132.17,132.17h37.76c12.59-12.59,25.18-25.18,37.76-37.76v-37.76c-12.59-12.59-25.18-25.18-37.76-37.76v37.76c6.29,6.29,12.59,12.59,18.88,18.88-9.44,9.44-18.88,18.88-28.32,28.32h-18.88c-37.76-37.76-75.53-75.53-113.29-113.29v-18.88c15.73-15.73,31.47-31.47,47.2-47.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.46,75.53h-37.76c12.59,12.59,25.18,25.18,37.76,37.76v-37.76Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJgSmboloBranco);
export default __webpack_public_path__ + "static/media/JG-Símbolo_Branco.88931f6f4523bc63308151eec2ae78a3.svg";
export { ForwardRef as ReactComponent };